
import {Component, Vue,} from "vue-property-decorator";
import {deepCopy} from "@/auxillary"
import DocumentEditDialog from "@/components/document/DocumentEditDialog.vue";
import {MdbsCore} from "@/api/tsclient";
import DocumentShortDto = MdbsCore.DocumentShortDto;
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {currentUserModule, documentModule} from "@/store";
import Rights = MdbsCore.Rights;

@Component({
  components: {
    DocumentEditDialog,
    ConfirmDialog
  }
})
export default class DocumentTable extends Vue {
  private _loading: boolean = false;

  headers: any = [
    {
      text: 'Titel',
      align: 'left',
      value: 'title'
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: "170px",
      value: 'actions'
    },
  ];

  canEditHeaders: any = [
    {
      text: 'Reihenfolge',
      align: 'left',
      value: 'order',
      width: "110px"
    },
    {
      text: 'Titel',
      align: 'left',
      value: 'title'
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: "170px",
      value: 'actions'
    },
  ];

  options: any = {
    sortBy: ['order'],
    sortDesc: [false]
  };
  search: string = "";

  itemToEdit: DocumentShortDto | null = null;
  itemToDelete: DocumentShortDto | null = null;

  showDocumentDialog = false;
  activeDocumentLink = "";
  activeDocumentDisplayName = "";
  activeDocumentFileName = "";

  async mounted() {
    await documentModule.loadAll()
  }

  get documents() {
    return documentModule.documents;
  }

  get sortedDocuments() {
   return this.documents.sort((d1, d2) => d1.order! >= d2.order! ? 1 : -1);
  }

  get loading() {
    return this._loading || documentModule.isLoading;
  }

  get showEditDialog() {
    return this.itemToEdit != null;
  }

  get canSeeDocument() {
    return currentUserModule.hasRight(Rights.DocumentGetAllCmd);
  }

  get canDownloadDocument() {
    return currentUserModule.hasRight(Rights.DocumentGetLatestContentVersionCmd);
  }

  get canEditDocument() {
    return currentUserModule.hasRight(Rights.DocumentUpdateCmd);
  }

  get canCreateDocument() {
    return currentUserModule.hasRight(Rights.DocumentCreateCmd);
  }

  get canDeleteDocument() {
    return currentUserModule.hasRight(Rights.DocumentDeleteCmd);
  }

  newDocument() {
    this.itemToEdit = new DocumentShortDto({id: ""})
    this.activeDocumentLink = "";
    this.activeDocumentDisplayName = "";
    this.activeDocumentFileName = "";
  }

  editDocument(document: DocumentShortDto) {
    this.itemToEdit = deepCopy(document);
  }

  async saveDocument(payload: { document: DocumentShortDto, file: File | null }) {
    if (this.itemToEdit == null)
      return;

    this.itemToEdit = null;
    if (payload.document.id == null || payload.document.id == "") {
      await documentModule.createDocument({
        identifier: payload.document.identifier ?? "",
        title: payload.document.title ?? "",
        description: payload.document.description ?? "",
        order: payload.document.order ?? 0,
        fileParam: {
          fileName: payload.file?.name ?? "",
          data: payload.file
        }
      });
    } else {
      if (payload.file == null) {
        await documentModule.updateDocument({
          id: payload.document.id,
          identifier: payload.document.identifier ?? "",
          title: payload.document.title ?? "",
          order: payload.document.order ?? 0,
          description: payload.document.description ?? ""
        });
      } else {
        await documentModule.updateDocumentWithContent({
          id: payload.document.id,
          title: payload.document.title ?? "",
          identifier: payload.document.identifier ?? "",
          order: payload.document.order ?? 0,
          description: payload.document.description ?? "",
          fileParam: {
            fileName: payload.file.name,
            data: payload.file
          }
        });
      }
    }
  }

  showDeleteDialog(item: DocumentShortDto) {
    this.itemToDelete = item;
  }

  async deleteDocument(documentId: string) {
    await documentModule.deleteDocument(documentId);
    this.itemToDelete = null;
  }

  async openDocument(doc: any) {
    this.showDocumentDialog = true
    this.activeDocumentDisplayName = doc.displayName;

    const fileResponse = await documentModule.download(doc.id)
    const fileUrl = URL.createObjectURL(fileResponse?.data)

    this.activeDocumentFileName = fileResponse?.fileName ?? "";
    this.activeDocumentLink = fileUrl;
  }
}
